/* ==========================================================================
   VPV FOOTER — Footer Menu accordion control.
   The Footer Menu block renders <details open> so desktop is expanded with no
   flash. On mobile, accordion-enabled menus collapse (remove `open`) and the
   native <details> toggle drives expand/collapse; desktop restores `open`.
   ========================================================================== */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  function apply() {
    document.querySelectorAll('.vpv-footer-menu--accordion').forEach(function (d) {
      if (mq.matches) {
        d.removeAttribute('open'); // mobile: start collapsed (native toggle expands)
      } else {
        d.setAttribute('open', ''); // desktop: always expanded
      }
    });
  }

  function init() {
    apply();
    if (mq.addEventListener) { mq.addEventListener('change', apply); }
    else if (mq.addListener) { mq.addListener(apply); } // older Safari
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
  // Theme editor re-render of the footer section.
  document.addEventListener('shopify:section:load', apply);
})();
